import { render, staticRenderFns } from "./OnboardingConfirmation.vue?vue&type=template&id=26144f0c&scoped=true"
import script from "./OnboardingConfirmation.vue?vue&type=script&lang=js"
export * from "./OnboardingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OnboardingConfirmation.vue?vue&type=style&index=0&id=26144f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26144f0c",
  null
  
)

export default component.exports